<template>
    <!-- <AppLayout title="Admins"> -->
         
         
         <v-card class="d-flex flex-column flex-grow-1 table-card overflow-visible" :class="tableCard.card.class" :rounded="tableCard.card.rounded">
             <v-card-text class="d-flex flex-column flex-grow-1" :class="tableCard.card.textClass">
                 <div class="d-flex align-center ga-3 px-3 px-md-0" :class="[tableCard.card.actionPad]">
                     <div class="d-flex flex-grow-1 min-w-0">
                         <div class="w-100 w-sm-20rem max-w-100">
                             <v-text-field
                                 v-model="datatable.request.search.value"
                                 :label="tableCard.searchInput.label"
                                 :placeholder="tableCard.searchInput.placeholder"
                                 :density="tableCard.searchInput.density"
                                 :flat="tableCard.searchInput.flat"
                                 :variant="tableCard.searchInput.variant"
                                 :single-line="tableCard.searchInput.singleLine"
                                 :hide-details="true"
                                 @update:model-value="() => datatable.onSearch()"
                                 clearable
                                 :class="[`table-action`, tableCard.searchInput.class]"
                             >
                             <template #prepend-inner >
                                 <span >
                                     <mdi-icon>search</mdi-icon>
                                 </span>
                             </template>
                             </v-text-field>
                         </div>
                     </div>
                     <div class="d-flex justify-end">
                         <div class="d-none d-sm-block">
                            <v-btn-input-compact text="Create Invoice" class="table-action" @click.prevent="openInviceDialog(0)">
                                <template #prepend>
                                    <mdi-icon>add</mdi-icon>
                                </template>
                            </v-btn-input-compact>
                         </div>
                         <div class="d-sm-none">
                             <v-btn-icon :color="tableCard.actionMenu.btn.color"  class="match-input-compact table-action" :variant="tableCard.actionMenu.btn.variant">
                                 <mdi-icon :size="tableCard.actionMenu.btn.iconSize">{{ tableCard.actionMenu.btn.icon }}</mdi-icon>
 
                                 <v-menu activator="parent" class="tiny-dropdown">
                                     <v-list>
                                        <v-list-item title="Create Invoice" value="create_invoice" @click.prevent="openInviceDialog(0)">
                                            <template #prepend>
                                                <mdi-icon>add</mdi-icon>
                                            </template>
                                        </v-list-item>
                                     </v-list>
                                 </v-menu>
                             </v-btn-icon>
                         </div>
                     </div>
                 </div>
                 <div class="d-flex-col-grow">
                     <DataTable :datatable="datatable" class="d-flex flex-column has-action"  >
                        <template v-slot:[`item.company`]="{ item }:{item: Invoice}" key="item.company">
                             <div>{{ item.company?.name }}</div>
                             <div class="text-secondary-light font-italic fw-medium fs-n5" v-if="item.is_bluebanc">Bluebanc</div>
                         </template>
                        <template v-slot:[`item.amount`]="{ item }:{item: Invoice}" key="item.amount">
                             <div>{{ helpers.moneyFormatNew(item.amount) }}</div>
                         </template>
                        <template v-slot:[`item.amount`]="{ item }:{item: Invoice}" key="item.amount">
                             <div>{{ helpers.moneyFormatNew(item.amount) }}</div>
                         </template>
                         <template v-slot:[`item.usable_amount`]="{ item }:{item: Invoice}" key="item.usable_amount">
                             <div>{{ helpers.moneyFormatNew(item.usable_amount) }}</div>
                         </template>
                         <template v-slot:[`item.status`]="{ item }:{item: Invoice}" key="item.status">
                             <div :class="`fw-medium text-no-wrap text-${item?.status_preview?.color ?? 'secondary'}`">{{ item?.status_preview?.name ?? 'Not found' }}</div>
                         </template>
                         <template v-slot:[`item.action`]="{ item }:{item: Invoice}" key="item.action">
                             <div>
                                 <div class="d-none d-md-block">
                                     <div class="d-flex justify-center">
                                         <v-tooltip text="Edit" v-if="item.is_editable">
                                             <template v-slot:activator="{ props }">
                                                <v-btn-icon-text color="primary" density="compact" v-bind="props" @click.prevent="openInviceDialog(item.id as number)">
                                                    <mdi-icon>edit_square</mdi-icon>
                                                </v-btn-icon-text>
                                             </template>
                                         </v-tooltip>
                                         <v-tooltip text="Download">
                                             <template v-slot:activator="{ props }">
                                                <a :href="route('invoices.download', item.id)" v-bind="props" target="new" >
                                                    <v-btn-icon-text color="warning"  density="compact" >
                                                        <mdi-icon>download</mdi-icon>
                                                    </v-btn-icon-text>
                                                </a>
                                             </template>
                                         </v-tooltip>
                                         <v-tooltip text="Mark as Paid" v-if="item.is_pending">
                                             <template v-slot:activator="{ props }">
                                                <v-btn-icon-text color="primary"  density="compact" v-bind="props" @click.prevent="confirmMarkAsPaid(item)" >
                                                    <mdi-icon>task_alt</mdi-icon>
                                                </v-btn-icon-text>
                                             </template>
                                         </v-tooltip>
                                     </div>
                                 </div>
                                 <div class="d-md-none">
                                     <v-btn-icon :color="tableCard.actionMenu.btn.color" density="compact" variant="plain">
                                         <mdi-icon>{{ tableCard.actionMenu.btn.icon }}</mdi-icon>
 
                                         <v-menu activator="parent" class="tiny-dropdown">
                                             <v-list min-width="120px" >
                                                <v-list-item title="Edit" value="edit_invoice"  v-if="item.is_editable" @click.prevent="openInviceDialog(item.id as number)">
                                                    <template #prepend>
                                                        <mdi-icon>edit_square</mdi-icon>
                                                    </template>
                                                </v-list-item>
                                                <a class="v-list-item-n-link" :href="route('invoices.download', item.id)" target="new" >
                                                    <v-list-item title="Download" value="download_invoice">
                                                        <template #prepend>
                                                            <mdi-icon>download</mdi-icon>
                                                        </template>
                                                    </v-list-item>
                                                </a>
                                                <v-list-item title="Mark as Paid" value="invoice_mark_as_paid"  v-if="item.is_pending" @click.prevent="confirmMarkAsPaid(item)">
                                                    <template #prepend>
                                                        <mdi-icon>task_alt</mdi-icon>
                                                    </template>
                                                </v-list-item>
                                             </v-list>
                                         </v-menu>
                                     </v-btn-icon>
                                 </div>
                             </div>
                             
                         </template>
                     </DataTable>
                 </div>
                 
                 
             </v-card-text>
         </v-card>
         <v-dialog v-model="markingAsPaid" width="auto" @afterLeave="markingAsPaid = false">
            <v-card max-width="100%" width="500">
                <v-card-title>Mark as Paid</v-card-title>
                <v-card-subtitle>Are you sure you want to mark this invoice as paid?</v-card-subtitle>
                <v-card-text class="py-2">
                    <div v-if="markAsPaidForm.errors.custom_error" class="text-error">{{ markAsPaidForm.errors.custom_error }}</div>
                </v-card-text>
                <v-card-actions-modal>
                    <v-btn
                        text="No"
                        color="btn-secondary"
                        @click="markingAsPaid = false"
                    ></v-btn>
                    <v-btn
                        :disabled="markAsPaidForm.processing"
                        :loading="markAsPaidForm.processing"
                        @click="markAsPaid"
                        color="primary"
                        text="Yes"
                    ></v-btn>
                </v-card-actions-modal>
            </v-card>
        </v-dialog>
         <InvoiceDialog v-model="manageInvoiceDialog" v-model:invoice-id="invoiceDialogInvoiceId" @updateInvoiceList="handleUpdateInvoiceList" ></InvoiceDialog>
    <!-- </AppLayout> -->
 </template>
 <script setup lang="ts">
    import { ref } from "vue";
    import { Page, GlobalEventCallback } from '@inertiajs/core';
    import { usePage, Link, useForm } from '@inertiajs/vue3';
    import { SharedPageProps } from '@/Types/inertia';
    import { Invoice } from '@/Types/Models/invoice';
    import { useDatatable, TableResponse } from '@/Composables/Datatable';
    import { toast } from "vue3-toastify";
    import { pageTitle, useTableCard, containerGapForTable } from '@/Composables/PageMeta';
    import DataTable from '@/Components/vuetify/DataTable.vue';
    import InvoiceDialog from '@/Pages/Invoices/Manage.vue';
    import helpers from '@/Plugins/helpers';

    containerGapForTable();
    type PageData = SharedPageProps & {
        data:{
            table?: TableResponse<Invoice>;
        };
    }
    const page = usePage<PageData>();
    pageTitle.value = 'Invoices';
    const datatable = useDatatable<Invoice>(route('invoices.index'), page.props.data.table);
    console.log(datatable.request.length)

    const tableCard = useTableCard();
    
    const manageInvoiceDialog = ref(false);
    const invoiceDialogCompanyId = ref(0);
    const invoiceDialogInvoiceId = ref(0);
    const openInviceDialog = (invoiceId: number = 0) => {
        invoiceDialogInvoiceId.value = invoiceId;
        manageInvoiceDialog.value = true;
    }

    const handleUpdateInvoiceList = () => {
        toast.success(page.props.jetstream?.flash?.msg?.text ?? 'Invoice saved');
        datatable.setTable(page.props.data.table ?? []);
    }

    const markAsPaidForm = useForm({
        custom_error: ''
    });
    const markingAsPaid = ref(false);
    const invoiceBeignMarked = ref<Invoice | null>(null);
    const confirmMarkAsPaid = async (invoice: Invoice) => {
        markAsPaidForm.reset();
        markAsPaidForm.clearErrors();
        invoiceBeignMarked.value = invoice;
        markingAsPaid.value = true;
    };

    const markAsPaid = () => {
        markAsPaidForm.post(route('invoices.markAsPaid', invoiceBeignMarked.value?.id ?? 0), {
            preserveScroll: true,
            onSuccess: ((page: Page<PageData>) => {
                markAsPaidForm.reset();
                invoiceBeignMarked.value = null;
                markingAsPaid.value = false;
                toast.success(page.props.jetstream?.flash?.msg?.text ?? 'Invoice marked as paid successfully');
                datatable.setTable(page.props.data.table);
            }) as GlobalEventCallback<"success">,
        });
    };
 </script>